import { render, staticRenderFns } from "./RendicontazioneListGroup.vue?vue&type=template&id=61806288&"
import script from "./RendicontazioneListGroup.vue?vue&type=script&lang=js&"
export * from "./RendicontazioneListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports